import {
  ColorsWhite,
  Dimensions2,
  Dimensions5,
  Dimensions7,
} from '@efexteam/design-tokens';
import { css } from '@emotion/css';

const wrapper = css({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: `${Dimensions5} 0`,
  backgroundColor: ColorsWhite,
});

const avatarWrapper = css({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: `${Dimensions2}`,
  flex: 1,
  marginRight: Dimensions7,

  img: {
    margin: 0,
    maxWidth: '100px',
  },
});

const HeaderStyles = {
  wrapper,
  avatarWrapper,
};

export default HeaderStyles;
